import ObjectType from './ObjectType';
const DateType = Object.seal({
    fullName: 'Date',
    name: 'Date',
    namespace: '',
    baseType: ObjectType,
    isArray: false,
    factory: Date
});
export default DateType;
